import { RootState } from '../../reducers'
import type { UploadProgressState } from './filesUploadProgress.model'

export const getFilesUploadState = (state: RootState): UploadProgressState => {
  return state.domain.filesUploadProgress
}
